import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = {
  class: "p-field p-col p-col-12 p-md-12 p-lg-6",
  style: {"font-size":"16px"}
}
const _hoisted_3 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_4 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_5 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_6 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_7 = { class: "p-field p-col p-col-12 p-md-12 p-lg-6" }
const _hoisted_8 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_9 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_10 = { class: "p-d-flex p-jc-between p-ai-center" }
const _hoisted_11 = {
  class: "p-input-icon-left",
  style: {"width":"18em"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Panel, { header: "Thêm xe" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[6] || (_cache[6] = _createElementVNode("label", { style: {"font-size":"16px"} }, "Tên chủ xe", -1)),
              _createVNode(_component_InputText, {
                id: "name",
                type: "text",
                modelValue: $setup.carObject.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.carObject.name) = $event)),
                style: {"text-align":"center","font-size":"16px"}
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _cache[7] || (_cache[7] = _createElementVNode("label", { style: {"font-size":"16px"} }, "Biển số xe", -1)),
              _createVNode(_component_InputText, {
                id: "plate_number",
                type: "text",
                modelValue: $setup.carObject.plate_number,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.carObject.plate_number) = $event)),
                style: {"text-align":"center","font-size":"16px"}
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _cache[8] || (_cache[8] = _createElementVNode("label", { style: {"font-size":"16px"} }, "Thêm xe", -1)),
              _createVNode(_component_Button, {
                label: "Thêm",
                icon: "pi pi-plus-circle",
                iconPos: "left",
                onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.createCar())),
                style: {"font-size":"16px"}
              })
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_Panel, { header: "Danh sách xe" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_DataTable, {
                loading: _ctx.isLoading,
                value: $setup.listCarObject,
                paginator: true,
                stripedRows: "",
                rows: 10,
                rowsPerPageOptions: [10,25,50],
                rowHover: true,
                filters: $setup.filters,
                "onUpdate:filters": _cache[5] || (_cache[5] = ($event: any) => (($setup.filters) = $event)),
                paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
                globalFilterFields: ['name'],
                currentPageReportTemplate: "Có tổng số {totalRecords} xe",
                columnResizeMode: "fit | expand"
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_Button, {
                      type: "button",
                      icon: "pi pi-filter-slash",
                      label: "Xoá",
                      class: "p-button-outlined",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.clearFilter())),
                      style: {"width":"6em"}
                    }),
                    _createElementVNode("span", _hoisted_11, [
                      _cache[9] || (_cache[9] = _createElementVNode("i", { class: "pi pi-search" }, null, -1)),
                      _createVNode(_component_InputText, {
                        modelValue: $setup.filters['global'].value,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.filters['global'].value) = $event)),
                        placeholder: "Tìm theo tên hoặc số điện thoại"
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_Column, {
                    field: "name",
                    header: "Tên chủ xe",
                    sortable: ""
                  }),
                  _createVNode(_component_Column, {
                    field: "plate_number",
                    header: "Biển số xe",
                    sortable: "",
                    style: {"font-weight":"bold"}
                  }),
                  _createVNode(_component_Column, {
                    field: "created_at",
                    header: "Ngày khởi tạo",
                    sortable: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      _createTextVNode(_toDisplayString($setup.formatDateTime(slotProps.data.created_at)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, { header: "Chỉnh sửa" }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_Button, {
                        class: "p-button-danger",
                        label: "Xoá",
                        icon: "pi pi-trash",
                        onClick: ($event: any) => ($setup.deleteCar(slotProps.data.id))
                      }, null, 8, ["onClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["loading", "value", "filters"])
            ])
          ])
        ]),
        _: 1
      })
    ])
  ]))
}